module.exports = __webpack_public_path__ + "img/Dry Herb.45d64b2c.jpg";